import React from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { selectIsAuthenticated } from '~modules/auth/store/auth-selectors';

import { selectIsTenantAuthenticated } from '~tenant-modules/auth/store/tenant-auth-selectors';

import { useAppSelector } from '~system/store/configure-store';

import { ROUTES } from '~app/router/routes';

export const LessorPrivateRoute = () => {
  const isLessorAuthenticated = useAppSelector(selectIsAuthenticated);
  const isTenantAuthenticated = useAppSelector(selectIsTenantAuthenticated);

  const location = useLocation();

  const route = isTenantAuthenticated ? ROUTES.TENANT_SCOPE : ROUTES.LOGIN;

  if (isLessorAuthenticated && isTenantAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  if (!isLessorAuthenticated) {
    const redirectTo = encodeURIComponent(
      location.pathname + location.search + location.hash,
    );

    return <Navigate to={`${route}?redirectTo=${redirectTo}`} replace />;
  }

  return <Outlet />;
};
